export const LANGUAGE = 'novataris-preferred-language';
export const ENVIRONMENT = 'novataris-selected-environment';
export const PREVIEW = 'novataris-see-preview';
export const COOKIE_CONSENT = 'CookieConsent';
export const COOKIE_CONSENT_LEGACY = 'CookieConsent-legacy';
export const COOKIE_CONSENT_VALUE = 'v1';
export const COOKIE_CONSENT_VALUE_DECLINE = 'v2';
